import { Component } from '@angular/core';
import { NavigationStart, Router } from '@angular/router';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent {
  subscription: any;
  constructor(private router: Router) {
    // this.subscription = router.events.subscribe((event) => {
    //   if (event instanceof NavigationStart) {
    //     let browserRefresh = !router.navigated;
    //     sessionStorage.setItem('session',JSON.stringify(data)
    //   }
    // });
   
  }
}
